const allData = {
  brand: "جميع الأذكار",
};

export default allData;
